/**
 * Eluum branding constants — single source of truth for shared assets.
 *
 * Assets are hosted in the public S3 bucket and referenced by email previews
 * in the admin panel. Update the URL here when the asset changes.
 */

export const NEWSLETTER_HEADER_IMAGE_URL =
    'https://eluum-public-assets-bucket.s3.us-west-2.amazonaws.com/newsletter-header.jpeg';

/**
 * Responsive header tweaks for narrow screens — mirrors newsletterHeaderStyles
 * in src/lambdas/shared/email/header.ts. Inject as a <style> block in previews.
 */
export const newsletterHeaderStyles = ``;

/**
 * Newsletter letterhead HTML — mirrors the real SES template in mailing-service.
 * Returns a <div>-wrapped header suitable for browser-rendered previews.
 * Update this alongside src/lambdas/shared/email/header.ts.
 */
export function buildNewsletterHeaderHtml(): string {
    return `
    <div class="nl-header" style="padding:0;line-height:0;">
      <a href="https://www.eluum.com" target="_blank" style="display:block;text-decoration:none;">
        <img src="${NEWSLETTER_HEADER_IMAGE_URL}" alt="Eluum newsletter header" width="600" style="display:block;width:100%;max-width:600px;height:auto;" />
      </a>
    </div>`;
}
